export default {
  getSellerPerformancePage: {
    url: '/sellerPerformance/page',
    method: 'post',
    desc: '店铺绩效分页接口'
  },
  getSellerPerformanceDetail: {
    url: '/sellerPerformance/detail',
    method: 'post',
    desc: '店铺绩效详情'
  },
}
